import { cn } from "@humanex/ui/libs";

export function Progress({
  className,
  value = 0,
  ...props
}: React.ComponentProps<"div"> & { value: number }) {
  return (
    <div
      data-slot="progress"
      className={cn("bg-gray-200 rounded-full relative h-2 w-full overflow-hidden", className)}
      {...props}
    >
      <div
        data-slot="progress-indicator"
        className="bg-primary-500 rounded-full h-full w-full flex-1 transition-all"
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    </div>
  );
}
